import React, { useContext, useEffect, useState } from 'react';
import {
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TablePagination,
} from '@deere/fuel-react';
import { AlertBox } from '../../components/AlertBox.jsx';
import { LoggedInContext } from '../../context/LoggedInContext';
import { errorBannerFromResponse } from '../../utils/errorBanner';

export const SeniorityList = () => {
    const [rows, setRows] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [alertMsg, setAlertMsg] = useState(null);
    const [alertVariant, setAlertVariant] = useState(false);
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const { makeRequest, authState } = useContext(LoggedInContext);

    useEffect(() => {
        let ignore = false;
        const fetchBids = async () => {
            setIsLoading(true);
            if (!ignore) {
                const response = await makeRequest(
                    process.env.REACT_APP_API_ENDPOINT + '/seniorityList'
                );
                if (response.ok) {
                    const responseData = await response.json();
                    const responseRows = [];
                    for (const key in responseData) {
                        responseRows.push({
                            firstName: responseData[key].firstName,
                            lastName: responseData[key].lastName,
                            department: responseData[key].department,
                        });
                    }
                    setRows(responseRows);
                } else {
                    setAlertMsg(
                        errorBannerFromResponse(
                            response,
                            'We are unable to retrieve the seniority list. Please try again later.'
                        ).message
                    );
                    setAlertVariant('error');
                }
            }
            setIsLoading(false);
        };
        fetchBids();

        // cleanup function that will ignore future results of fetch triggered by the useEffect hook
        return () => {
            ignore = true;
        };
    }, [authState, makeRequest]);

    const columns = [
        { id: 'unitFacility', label: 'Unit Facility' },
        { id: 'firstName', label: 'First Name' },
        { id: 'lastName', label: 'Last Name' },
        { id: 'seniorityDate', label: 'Seniority Date' },
        { id: 'department', label: 'Department' },
    ];

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    return (
        <Paper sx={{ width: '100%', overflow: 'hidden' }}>
            {alertVariant && <AlertBox variant={alertVariant} msg={alertMsg} />}
            {!isLoading && (
                <TableContainer>
                    <Table stickyHeader aria-label="sticky table">
                        <TableHead>
                            <TableRow>
                                {columns.map((column) => (
                                    <TableCell
                                        key={column.id}
                                        align={column.align}
                                        style={{ minWidth: column.minWidth }}
                                    >
                                        {column.label}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows
                                .slice(
                                    page * rowsPerPage,
                                    page * rowsPerPage + rowsPerPage
                                )
                                .map((row, index) => {
                                    return (
                                        <TableRow
                                            hover
                                            tabIndex={-1}
                                            key={index}
                                        >
                                            {columns.map((column) => {
                                                const value = row[column.id];
                                                return (
                                                    <TableCell
                                                        key={column.id}
                                                        align={column.align}
                                                    >
                                                        {column.format &&
                                                        typeof value ===
                                                            'number'
                                                            ? column.format(
                                                                  value
                                                              )
                                                            : value}
                                                    </TableCell>
                                                );
                                            })}
                                        </TableRow>
                                    );
                                })}
                        </TableBody>
                    </Table>
                </TableContainer>
            )}
            {!isLoading && (
                <TablePagination
                    rowsPerPageOptions={[10, 25, 100]}
                    component="div"
                    count={rows.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            )}
        </Paper>
    );
};
